import { render, staticRenderFns } from "./GalleryBig3.vue?vue&type=template&id=625ed10c&scoped=true&"
import script from "./GalleryBig3.vue?vue&type=script&lang=js&"
export * from "./GalleryBig3.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig3.vue?vue&type=style&index=0&id=625ed10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ed10c",
  null
  
)

export default component.exports